import { Container } from 'styles/global'
import { useLanguage } from 'languages/language'
import { ProjectIntro } from '../projectintro'
import { Detail } from '../detail'
const VoicesOfTheBrave = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <ProjectIntro project={texts.voicesofthebrave} />
      <Detail
        dir="left"
        media={texts.voicesofthebrave.imgs[0]}
        text={texts.voicesofthebrave.texts[0]}
      />
      <Detail
        dir="right"
        media={texts.voicesofthebrave.imgs[1]}
        text={texts.voicesofthebrave.texts[1]}
      />
      <Detail
        dir="left"
        media={texts.voicesofthebrave.imgs[2]}
        text={texts.voicesofthebrave.texts[2]}
      />
      <Detail
        dir="right"
        media={texts.voicesofthebrave.imgs[3]}
        text={texts.voicesofthebrave.texts[3]}
      />
    </Container>
  )
}
export default VoicesOfTheBrave
